// One-line diagnostics footer appended to user-submitted reports (game
// reports + the contact form). Reports like "B presses register several
// times on my controller" can't be triaged remotely without (a) the build
// the user is actually running — iOS service workers are notorious for
// serving stale bundles long after a deploy — and (b) the gamepad flicker
// counters from the live input handler (the contact-flicker class of input
// bugs). BUILD_VERSION/BUILD_SHA are esbuild-injected globals; window.app is
// read defensively because the library bundle and logged-out pages have no
// emulator session.

export function diagnosticsFooter() {
  const version = typeof BUILD_VERSION === 'string' ? BUILD_VERSION : 'dev';
  const sha = typeof BUILD_SHA === 'string' && BUILD_SHA ? ` (${BUILD_SHA.slice(0, 7)})` : '';
  const parts = [`v${version}${sha}`];

  const input = globalThis.app?.input;
  if (input && input._padSeenAt > -Infinity) {
    parts.push(
      `gamepad flicker: ${input._padFlickerAbsorbed ?? 0} absorbed / ${input._padFlickerLeaked ?? 0} leaked`,
    );
  }

  return `[diagnostics] ${parts.join(' · ')}`;
}

/**
 * Join the user's prose with the diagnostics footer without exceeding the
 * server's body cap (MAX_BODY_SIZE in routes/contact.js). The footer always
 * survives; over-long prose is trimmed instead.
 */
export function bodyWithDiagnostics(userBody, maxLen = 10_000) {
  const footer = diagnosticsFooter();
  const maxUser = Math.max(0, maxLen - footer.length - 2); // 2 = '\n\n'
  return [userBody.slice(0, maxUser), footer].filter(Boolean).join('\n\n');
}
